import React, { useEffect, useState } from 'react';
import { Button } from '../UI/Button';
interface PaystackPaymentProps {
  amount: number; // in naira
  email: string;
  name?: string;
  phone?: string;
  onSuccess?: (reference: string) => void;
  onClose?: () => void;
}
export const PaystackPayment: React.FC<PaystackPaymentProps> = ({
  amount,
  email,
  name,
  phone,
  onSuccess,
  onClose
}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  useEffect(() => {
    // Check if PaystackPop is already available
    if (window.PaystackPop) {
      setIsScriptLoaded(true);
      return;
    }
    // This will help prevent potential stream abort errors by ensuring
    // the script is properly loaded before trying to use it
    const script = document.querySelector('script[src*="paystack"]');
    if (script) {
      script.addEventListener('load', () => {
        setIsScriptLoaded(true);
      });
    }
  }, []);
  const initializePayment = () => {
    if (!isScriptLoaded) {
      console.error('Paystack script not loaded yet');
      return;
    }
    setIsProcessing(true);
    try {
      // @ts-ignore - PaystackPop is loaded via script
      const handler = window.PaystackPop?.setup({
        key: 'pk_live_c2f71547b29d95243a012d9ef2f8e03485d942e7',
        email,
        amount: amount * 100,
        name: name || 'The Networking Salon',
        phone,
        callback: (response: any) => {
          setIsProcessing(false);
          if (onSuccess) onSuccess(response.reference);
        },
        onClose: () => {
          setIsProcessing(false);
          if (onClose) onClose();
        }
      });
      handler.openIframe();
    } catch (error) {
      console.error('Error initializing Paystack payment:', error);
      setIsProcessing(false);
    }
  };
  return <div className="w-full" data-id="element-1034">
      <Button onClick={initializePayment} disabled={isProcessing || !isScriptLoaded} className="w-full" data-id="element-1035">
        {isProcessing ? 'Processing...' : `Pay ₦${amount.toLocaleString()}`}
      </Button>
    </div>;
};